import { render, staticRenderFns } from "./CreateGroupSuccessCard.vue?vue&type=template&id=cee0b09a"
import script from "./CreateGroupSuccessCard.vue?vue&type=script&lang=js"
export * from "./CreateGroupSuccessCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cee0b09a')) {
      api.createRecord('cee0b09a', component.options)
    } else {
      api.reload('cee0b09a', component.options)
    }
    module.hot.accept("./CreateGroupSuccessCard.vue?vue&type=template&id=cee0b09a", function () {
      api.rerender('cee0b09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/CreateGroupSuccessCard.vue"
export default component.exports